
import { useState } from 'react';
import { 
  TableRow, 
  TableCell 
} from '@/components/ui/table';
import { User } from '@/types/user';
import { UserAvatar } from './UserAvatar';
import { UserRoleBadge } from './UserRoleBadge';
import { UserStatusDisplay } from './UserStatusDisplay';
import { UserActionsMenu } from './UserActionsMenu';
import { UserDialogs } from './UserDialogs';

interface UserTableRowProps {
  user: User;
  onUserUpdated: () => void;
}

export function UserTableRow({ user, onUserUpdated }: UserTableRowProps) {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [roleDialogOpen, setRoleDialogOpen] = useState(false);
  const [deactivateDialogOpen, setDeactivateDialogOpen] = useState(false);
  const [resendInvitationDialogOpen, setResendInvitationDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  return (
    <>
      <TableRow key={user.id}>
        <TableCell>
          <UserAvatar user={user} />
        </TableCell>
        <TableCell>
          <span className="text-sm text-muted-foreground">{user.organization_name || '—'}</span>
        </TableCell>
        <TableCell>
          <UserRoleBadge user={user} />
        </TableCell>
        <TableCell>
          <UserStatusDisplay user={user} />
        </TableCell>
        <TableCell>
          {user.invitedAt ? new Date(user.invitedAt).toLocaleDateString() : 'N/A'}
        </TableCell>
        <TableCell>
          <UserActionsMenu
            user={user}
            onEditUser={() => setEditDialogOpen(true)}
            onChangeRole={() => setRoleDialogOpen(true)}
            onResendInvitation={() => setResendInvitationDialogOpen(true)}
            onDeactivateUser={() => setDeactivateDialogOpen(true)}
            onDeleteUser={() => setDeleteDialogOpen(true)}
          />
        </TableCell>
      </TableRow>

      <UserDialogs
        user={user}
        editDialogOpen={editDialogOpen}
        setEditDialogOpen={setEditDialogOpen}
        roleDialogOpen={roleDialogOpen}
        setRoleDialogOpen={setRoleDialogOpen}
        deactivateDialogOpen={deactivateDialogOpen}
        setDeactivateDialogOpen={setDeactivateDialogOpen}
        resendInvitationDialogOpen={resendInvitationDialogOpen}
        setResendInvitationDialogOpen={setResendInvitationDialogOpen}
        deleteDialogOpen={deleteDialogOpen}
        setDeleteDialogOpen={setDeleteDialogOpen}
        onUserUpdated={onUserUpdated}
      />
    </>
  );
}
